import { Component, EventEmitter, Input, Output, Provider } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { PaymentMethod, PaymentType, ProviderType } from '../../models/provider.model';

@Component({
  selector: 'app-create-provider-modal',
  templateUrl: './create-provider-modal.component.html',
  styleUrl: './create-provider-modal.component.scss'
})
export class CreateProviderModalComponent {
  @Input() showProviderModal: boolean = false;
  @Input() providerTypes: ProviderType[] = [];
  @Input() paymentTypes: PaymentType[] = [];
  @Input() paymentMethods: PaymentMethod[] = [];

  @Output() createProvider: EventEmitter<Provider> = new EventEmitter<Provider>();
  @Output() closeModal: EventEmitter<void> = new EventEmitter<void>();

  public providerForm: any;

  constructor(private fb: FormBuilder) {
    this.providerForm = this.fb.group({
      id: [''],
      providerKey: ['', [Validators.required, Validators.minLength(2)]],
      providerRFC: ['', [Validators.required, Validators.pattern('^[A-Za-zñÑ&]{3,4}\\d{6}\\w{3}$')]],
      providerLegalName: ['', [Validators.required, Validators.minLength(2)]],
      providerShortName: ['', [Validators.required, Validators.minLength(2)]],
      providerFirstName: ['', [Validators.required, Validators.minLength(2)]],
      providerLastName: ['', [Validators.required, Validators.minLength(2)]],
      providerTelephone: ['', [Validators.required, Validators.minLength(10)]],
      providerEmail: ['', [Validators.required, Validators.pattern('^\\S+@\\S+\\.\\S+$')]],
      providerTypeId: [null, [Validators.required, Validators.min(1)]],
      paymentTypeId: [null, [Validators.required, Validators.min(0)]],
      paymentMethodId: [null, [Validators.required, Validators.min(0)]],
    });
  }

  handleCancelModal() {
    this.closeModal.emit();
    this.providerForm.reset();
  }

  onCreateProvider() {
    const newProvider = this.providerForm.value;
    this.createProvider.emit(newProvider);
  }
}
